import { render, staticRenderFns } from "./WorkClaimDocuments.vue?vue&type=template&id=03eb131a&scoped=true&"
import script from "./WorkClaimDocuments.vue?vue&type=script&lang=js&"
export * from "./WorkClaimDocuments.vue?vue&type=script&lang=js&"
import style0 from "./WorkClaimDocuments.vue?vue&type=style&index=0&id=03eb131a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03eb131a",
  null
  
)

export default component.exports